import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "not-found-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.offerNotFound), 1 /* TEXT */)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "not-found-content" }, null, -1 /* CACHED */))
  ]))
}